// 机构展示
export default[

  {
    path: '/institution/index',
    name: '创投机构展示',
    component: () => import(/* webpackChunkName: 'institution' */ '@/views/institution/list.vue')
  },
  {
    path: '/institution/detail/:id',
    name: '创投机构详情',
    component: () => import(/* webpackChunkName: 'institution' */ '@/views/institution/detail.vue')
  }
]



// WEBPACK FOOTER //
// ./src/router/moudles/institutionRouter.js